import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=a9abf156&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=a9abf156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9abf156",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9abf156')) {
      api.createRecord('a9abf156', component.options)
    } else {
      api.reload('a9abf156', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=a9abf156&scoped=true&", function () {
      api.rerender('a9abf156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8IQY83S82DX3I/JS/comp/GuestBox.vue"
export default component.exports